import { useEffect, useState, type ComponentType } from 'react'
import { createPortal } from 'react-dom'

import Footer from '../Footer'

// the FooterPortal is created for the sake of enhancing of CLS metric
// it allows to render the Footer at a more appropriate moment
export default function FooterPortal() {
  const [parenNode, setParentNode] = useState(null)

  useEffect(() => {
    const parentNode = document.getElementById('ui-layout-content-node')?.parentElement || document.body

    setParentNode(parentNode)
  }, [])

  if (!parenNode) {
    return null
  }

  return createPortal(<Footer />, parenNode)
}

type HOCProps = {
  isFooterVisible: boolean
}
export function withFooterPortal<T extends HOCProps>(Component: ComponentType<Omit<T, keyof HOCProps>>) {
  const Wrapper = ({ isFooterVisible, ...props }: T) => {
    return (
      <>
        <Component {...props} />
        {isFooterVisible && <FooterPortal />}
      </>
    )
  }

  Wrapper.displayName = `withFooterPortal(${Component.displayName || Component.name})`

  return Wrapper
}
